import PropTypes from 'prop-types';
import clinician from './clinician';
import grade from './grade';
import availability from './availability';
import orgUnit from './orgUnit';
import timePropTypes from './time';

const posting = PropTypes.shape({
  availabilities: PropTypes.arrayOf(availability).isRequired,
  clinician: clinician.isRequired,
  ragCapacity: PropTypes.number.isRequired,
  grade: grade.isRequired,
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  orgUnit: orgUnit.isRequired,
  workingTime: timePropTypes.isRequired,
  assignedTime: timePropTypes.isRequired,
  availableTime: timePropTypes.isRequired,
});

export default posting;
